(function () {
  if (window.MedBoundJunipV2) return;

  var productPalettes = {
    retaker:   { tint: 'rgba(164, 214, 136, 0.070)', hoverTint: 'rgba(164, 214, 136, 0.135)', accent: '#78b95f', dot: '#ef5b5b', pillBg: '#eef8e8', pillText: '#536f2c' },
    cars:      { tint: 'rgba(134, 163, 255, 0.065)', hoverTint: 'rgba(134, 163, 255, 0.125)', accent: '#6f89ee', dot: '#ef5b5b', pillBg: '#edf1ff', pillText: '#4354b6' },
    essay:     { tint: 'rgba(225, 146, 218, 0.070)', hoverTint: 'rgba(225, 146, 218, 0.130)', accent: '#cf78c9', dot: '#ef5b5b', pillBg: '#faecf9', pillText: '#914486' },
    personal:  { tint: 'rgba(111, 205, 191, 0.065)', hoverTint: 'rgba(111, 205, 191, 0.125)', accent: '#60bcae', dot: '#ef5b5b', pillBg: '#eaf9f5', pillText: '#24756c' },
    secondary: { tint: 'rgba(178, 151, 239, 0.068)', hoverTint: 'rgba(178, 151, 239, 0.128)', accent: '#9a80dc', dot: '#ef5b5b', pillBg: '#f1ecff', pillText: '#684bab' },
    general:   { tint: 'rgba(188, 169, 224, 0.060)', hoverTint: 'rgba(188, 169, 224, 0.115)', accent: '#9276c5', dot: '#ef5b5b', pillBg: '#f3effb', pillText: '#604887' }
  };

  var avatarBackgrounds = [
    ['#ffd7ea', '#7d4cff'], ['#d7f3ff', '#1e64da'], ['#e1f8d1', '#ec7b37'], ['#efe1ff', '#4d58c8'],
    ['#ffe6c8', '#0e84a4'], ['#d8f7ef', '#7737b9'], ['#f9d9ef', '#126a9d'], ['#e0e8ff', '#de6a3c'],
    ['#f7e4c7', '#3b64b8'], ['#d6f1ff', '#a94791'], ['#e8f5d9', '#4552ba'], ['#f5d9ff', '#18878a'],
    ['#ffe4dc', '#334b9e'], ['#dcf6ec', '#9b4b80'], ['#e6e1ff', '#db7538'], ['#fbe2f0', '#236f9a']
  ];

  var skinTones = ['#f4c8a4','#e8b184','#d89867','#c57c52','#a96342','#7f452f','#5d3428','#b86f4a'];
  var hairTones = ['#211b1a','#30231f','#160f10','#4b3027','#241c24'];
  var shirtTones = ['#64d2bf','#6da5ef','#a887e8','#f09aaa','#77c781','#f5a45f','#566cc8','#53b8c7'];

  function hashString(str) {
    var h = 2166136261;
    str = String(str || 'MedBound reviewer');
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h += (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24);
    }
    return h >>> 0;
  }

  function detectProductTone(label) {
    var t = (label || '').toLowerCase();
    if (t.indexOf('cars') !== -1) return 'cars';
    if (t.indexOf('secondary') !== -1) return 'secondary';
    if (t.indexOf('essay') !== -1 || t.indexOf('writing audit') !== -1 || t.indexOf('feedback') !== -1) return 'essay';
    if (t.indexOf('personal statement') !== -1 || t.indexOf('statement guide') !== -1) return 'personal';
    if (t.indexOf('retaker') !== -1 || t.indexOf('mcat') !== -1) return 'retaker';
    return 'general';
  }

  function cleanProductLabel(text) {
    var value = String(text || '').replace(/\s+/g, ' ').trim();
    value = value.replace(/^(review\s+for|reviewed\s+product|review\s+of|reviewed|product)\s*:?\s*/i, '');
    return value.trim();
  }

  function avatarSvg(seed) {
    var bg = avatarBackgrounds[seed % avatarBackgrounds.length];
    var skin = skinTones[(seed >>> 3) % skinTones.length];
    var hair = hairTones[(seed >>> 6) % hairTones.length];
    var shirt = shirtTones[(seed >>> 9) % shirtTones.length];
    var hairStyle = (seed >>> 12) % 6;
    var glasses = ((seed >>> 15) % 4) === 0;
    var freckles = ((seed >>> 17) % 5) === 0;
    var earring = ((seed >>> 20) % 6) === 0;

    var hairMarkup = '';
    if (hairStyle === 0) hairMarkup = '<path d="M17 29c0-14 8-21 19-21 12 0 20 8 19 22-6-7-12-9-20-9-7 0-12 2-18 8Z" fill="'+hair+'"/>';
    if (hairStyle === 1) hairMarkup = '<path d="M16 31c1-16 8-23 20-23 9 0 17 5 19 17-5-4-10-6-17-6-9 0-16 4-22 12Z" fill="'+hair+'"/><circle cx="21" cy="19" r="5" fill="'+hair+'"/><circle cx="29" cy="14" r="6" fill="'+hair+'"/><circle cx="39" cy="14" r="6" fill="'+hair+'"/><circle cx="48" cy="20" r="5" fill="'+hair+'"/>';
    if (hairStyle === 2) hairMarkup = '<path d="M17 27c2-14 8-20 19-20 12 0 18 8 19 21-4-6-9-10-18-10-8 0-14 3-20 9Z" fill="'+hair+'"/><path d="M18 18c7-9 28-11 35 1-10-5-26-5-35-1Z" fill="'+hair+'"/>';
    if (hairStyle === 3) hairMarkup = '<path d="M15 29c0-13 8-22 20-22 13 0 21 8 21 23-5-7-10-10-20-10-9 0-15 4-21 9Z" fill="'+hair+'"/><path d="M15 27c1 18 1 23 5 29h6l-2-28-9-1Zm42 1-9 0-2 28h6c4-7 4-12 5-28Z" fill="'+hair+'"/>';
    if (hairStyle === 4) hairMarkup = '<path d="M17 30c0-15 7-23 19-23 11 0 18 7 19 20-4-5-8-8-15-9l-3-7-3 7c-8 1-12 4-17 12Z" fill="'+hair+'"/>';
    if (hairStyle === 5) hairMarkup = '<path d="M17 28c1-13 8-21 19-21 11 0 18 7 19 20-7-5-12-7-19-7-7 0-13 2-19 8Z" fill="'+hair+'"/><path d="M20 17c4-8 27-10 32 0-8-3-24-4-32 0Z" fill="'+hair+'"/>';

    var glassesMarkup = glasses ? '<g fill="none" stroke="#27334d" stroke-width="1.8"><rect x="20" y="29" width="12" height="8" rx="3"/><rect x="39" y="29" width="12" height="8" rx="3"/><path d="M32 33h7"/></g>' : '';
    var frecklesMarkup = freckles ? '<g fill="#9a5a42" opacity=".55"><circle cx="26" cy="37" r=".8"/><circle cx="29" cy="38" r=".7"/><circle cx="43" cy="37" r=".8"/><circle cx="40" cy="38" r=".7"/></g>' : '';
    var earringMarkup = earring ? '<circle cx="52.5" cy="38" r="1.5" fill="#f8c94e"/>' : '';

    return '<svg class="mb-review-avatar-art" viewBox="0 0 72 72" role="img" aria-label="Illustrated reviewer avatar" xmlns="http://www.w3.org/2000/svg">'+
      '<defs><linearGradient id="mbg'+seed+'" x1="0" y1="0" x2="1" y2="1"><stop stop-color="'+bg[0]+'"/><stop offset="1" stop-color="#ffffff"/></linearGradient></defs>'+
      '<circle cx="36" cy="36" r="36" fill="url(#mbg'+seed+')"/>'+
      '<circle cx="58" cy="14" r="9" fill="'+bg[1]+'" opacity=".16"/>'+
      '<circle cx="13" cy="57" r="10" fill="'+bg[1]+'" opacity=".12"/>'+
      '<path d="M12 72c3-17 13-25 24-25 12 0 21 8 24 25H12Z" fill="'+shirt+'"/>'+
      '<path d="M31 49h10l3 11-8 6-8-6 3-11Z" fill="#f8f9ff" opacity=".92"/>'+
      hairMarkup+
      '<ellipse cx="36" cy="33" rx="18" ry="20" fill="'+skin+'"/>'+
      '<ellipse cx="18.5" cy="35" rx="2.8" ry="5" fill="'+skin+'"/><ellipse cx="53.5" cy="35" rx="2.8" ry="5" fill="'+skin+'"/>'+
      '<path d="M25 30c2-1 4-1 6 0M41 30c2-1 4-1 6 0" stroke="#4b332d" stroke-width="1.5" stroke-linecap="round"/>'+
      '<circle cx="28.5" cy="33.5" r="1.25" fill="#2b2832"/><circle cx="43.5" cy="33.5" r="1.25" fill="#2b2832"/>'+
      '<path d="M35 34.5c-.5 3-.6 5 .7 6" stroke="#9e644f" stroke-width="1.1" fill="none" stroke-linecap="round"/>'+
      '<path d="M29 44c4 3.2 10 3.2 14 0" stroke="#8d3d50" stroke-width="1.8" fill="none" stroke-linecap="round"/>'+
      '<path d="M31 44.3c3 1.4 7 1.4 10 0" stroke="#fff" stroke-width="1" opacity=".9"/>'+
      frecklesMarkup+glassesMarkup+earringMarkup+
      '</svg>';
  }

  function verifiedBadge() {
    return '<span class="mb-review-verified"><svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="9" fill="#3d78df"/><path d="M5.7 10.2 8.5 13l5.9-6" fill="none" stroke="#fff" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Verified Buyer</span></span>';
  }

  function setProductPill(card) {
    var product = card.querySelector('.junip-review-product');
    if (!product) return '';

    var anchor = product.querySelector('a');
    var raw = anchor ? anchor.textContent : product.textContent;
    var label = cleanProductLabel(raw);
    if (!label) return '';

    Array.prototype.forEach.call(product.childNodes, function(node) {
      if (node.nodeType === 3) node.textContent = '';
    });

    if (anchor) {
      anchor.textContent = label;
    } else {
      product.textContent = '';
      var pill = document.createElement('span');
      pill.className = 'mb-review-product-pill';
      pill.textContent = label;
      product.appendChild(pill);
    }

    var body = card.querySelector('.junip-review-body');
    if (body && body.nextElementSibling !== product) body.insertAdjacentElement('afterend', product);
    return label;
  }

  function moveCoreOrder(card) {
    var customer = card.querySelector('.junip-review-customer');
    var stars = card.querySelector('.junip-star-ratings-container');
    var title = card.querySelector('.junip-review-title');
    var body = card.querySelector('.junip-review-body');

    if (customer && stars && customer.nextElementSibling !== stars) customer.insertAdjacentElement('afterend', stars);
    if (stars && title && stars.nextElementSibling !== title) stars.insertAdjacentElement('afterend', title);
    if (title && body && title.nextElementSibling !== body) title.insertAdjacentElement('afterend', body);
  }

  function enhanceCustomer(card, seed) {
    var customer = card.querySelector('.junip-review-customer');
    var avatar = card.querySelector('.junip-avatar');
    if (!avatar && customer) {
      avatar = document.createElement('div');
      avatar.className = 'junip-avatar';
      customer.insertBefore(avatar, customer.firstChild);
    }
    if (avatar && !avatar.querySelector('.mb-review-avatar-art')) avatar.innerHTML = avatarSvg(seed);

    var name = card.querySelector('.junip-customer-name');
    if (!name) return;

    var wrap = name.closest('.mb-review-name-line');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'mb-review-name-line';
      name.parentNode.insertBefore(wrap, name);
      wrap.appendChild(name);
    }
    if (!wrap.querySelector('.mb-review-verified')) wrap.insertAdjacentHTML('beforeend', verifiedBadge());
  }

  function applyProductStyling(card, productLabel) {
    var tone = detectProductTone(productLabel);
    var palette = productPalettes[tone] || productPalettes.general;
    card.style.setProperty('--mb-review-tint', palette.tint);
    card.style.setProperty('--mb-review-hover-tint', palette.hoverTint);
    card.style.setProperty('--mb-review-accent', palette.accent);
    card.style.setProperty('--mb-pill-dot', '#ef5b5b');
    card.style.setProperty('--mb-pill-bg', palette.pillBg);
    card.style.setProperty('--mb-pill-text', palette.pillText);
    card.dataset.mbProductTone = tone;
  }

  function enhanceCard(card) {
    if (!card) return;

    /* Junip can append the product metadata a moment after the card shell.
       If the card was already enhanced, make one additional pass only when
       a newly-arrived product node still needs its pill treatment. */
    if (card.dataset.mbReviewV2 === '1') {
      var lateProduct = card.querySelector('.junip-review-product');
      if (!lateProduct || lateProduct.dataset.mbProductV2 === '1') return;
      var lateLabel = setProductPill(card);
      if (lateLabel) {
        lateProduct.dataset.mbProductV2 = '1';
        applyProductStyling(card, lateLabel);
      }
      return;
    }

    var nameEl = card.querySelector('.junip-customer-name');
    var reviewerName = nameEl ? nameEl.textContent.trim() : 'MedBound reviewer';
    var seed = hashString(reviewerName);

    moveCoreOrder(card);
    var productLabel = setProductPill(card);
    var productNode = card.querySelector('.junip-review-product');
    if (productNode && productLabel) productNode.dataset.mbProductV2 = '1';
    applyProductStyling(card, productLabel);

    enhanceCustomer(card, seed);
    card.classList.add('mb-review-v2-card');
    card.dataset.mbReviewV2 = '1';
  }


  function initSummaryBarAnimation(root) {
    if (!root) return;
    var summaries = root.querySelectorAll('.junip-product-review-summary-wrapper');
    Array.prototype.forEach.call(summaries, function(summary) {
      if (summary.dataset.mbBarsInit === '1') return;
      var bars = summary.querySelectorAll('.junip-product-review-bar-filled');
      if (!bars.length) return;
      summary.dataset.mbBarsInit = '1';

      Array.prototype.forEach.call(bars, function(bar) {
        var target = '';
        var inline = bar.getAttribute('style') || '';
        var m = inline.match(/width\s*:\s*([\d.]+)%/i);
        if (m) target = m[1] + '%';
        if (!target) {
          var track = bar.parentElement;
          if (track) {
            var tw = track.getBoundingClientRect().width;
            var bw = bar.getBoundingClientRect().width;
            if (tw > 0) target = Math.max(0, Math.min(100, (bw / tw) * 100)) + '%';
          }
        }
        if (!target) return;
        bar.dataset.mbTargetWidth = target;
        bar.style.transition = 'none';
        bar.style.width = '0%';
      });

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          requestAnimationFrame(function() {
            Array.prototype.forEach.call(bars, function(bar) {
              if (!bar.dataset.mbTargetWidth) return;
              bar.style.transition = 'width 1s cubic-bezier(.22,.8,.26,1)';
              bar.style.width = bar.dataset.mbTargetWidth;
            });
          });
          observer.disconnect();
        });
      }, { threshold: 0.35 });
      observer.observe(summary);
    });
  }

  function enhanceRoot(root) {
    if (!root) return;
    root.classList.add('mb-junip-v2');
    var cards = root.querySelectorAll('.junip-review-list-item-container');
    Array.prototype.forEach.call(cards, enhanceCard);
    initSummaryBarAnimation(root);
  }

  function init(root) {
    if (!root || root.dataset.mbJunipV2Init === '1') return;
    root.dataset.mbJunipV2Init = '1';

    enhanceRoot(root);

    // Junip swaps the summary/filter DOM when Product/Store tabs change.
    // Briefly suppress the decorative offset layer during the swap so no stale
    // edge remains painted, then re-enhance only after Junip owns the tab click.
    root.addEventListener('click', function(event) {
      var tab = event.target.closest && event.target.closest('.junip-reviews-tab');
      if (!tab) return;
      root.classList.add('mb-junip-tab-switching');
      window.setTimeout(function() {
        enhanceRoot(root);
        // Force a repaint before bringing the offset layer back.
        void root.offsetHeight;
        root.classList.remove('mb-junip-tab-switching');
      }, 180);
    });

    var observer = new MutationObserver(function(mutations) {
      var needsRun = false;
      mutations.forEach(function(mutation) {
        if (mutation.target && mutation.target.closest && mutation.target.closest('.junip-review-list-item-container')) needsRun = true;
        Array.prototype.forEach.call(mutation.addedNodes || [], function(node) {
          if (node.nodeType !== 1) return;
          if ((node.matches && (node.matches('.junip-review-list-item-container') || node.matches('.junip-product-review-summary-wrapper') || node.matches('.junip-review-product'))) ||
              (node.querySelector && (node.querySelector('.junip-review-list-item-container') || node.querySelector('.junip-product-review-summary-wrapper') || node.querySelector('.junip-review-product')))) {
            needsRun = true;
          }
        });
      });
      if (needsRun) window.requestAnimationFrame(function() { enhanceRoot(root); });
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  function initWhenReady(selector, tries) {
    var root = document.querySelector(selector);
    if (root) {
      init(root);
      return;
    }
    if ((tries || 0) < 50) setTimeout(function() { initWhenReady(selector, (tries || 0) + 1); }, 120);
  }

  window.MedBoundJunipV2 = { init: init, initWhenReady: initWhenReady, enhanceRoot: enhanceRoot };
})();
